import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router);

const notFind = resolve => require(['@/views/notFind/index.vue'], resolve);
const home = resolve => require(['@/views/home/index.vue'], resolve);                                     // 登录注册
const quotaQuery = resolve => require(['@/views/quotaQuery/index.vue'], resolve);                               // 额度查询
//const quotaQueryEntry = resolve => require(['@/views/quotaQuery/entry/index.vue'], resolve);                    // 额度查询-入口页面
const quotaQueryFaceidVerify = resolve => require(['@/views/quotaQuery/faceidVerify/index.vue'], resolve);                    // 额度查询-人脸认证
const formAdditional = resolve => require(['@/views/quotaQuery/formAdditional/index.vue'], resolve);                  // 额度查询-人脸认证
const idCardConfirm = resolve => require(['@/views/quotaQuery/idCardConfirm/index.vue'], resolve);                  // 额度查询-ocr信息确认页
//const infoAdditional = resolve => require(['@/views/quotaQuery/infoAdditional/index.vue'], resolve);            // 额度查询-补充信息
const quotaQueryResult = resolve => require(['@/views/quotaQuery/result/index.vue'], resolve);                  // 额度查询结果
const quotaQueryPolling = resolve => require(['@/views/quotaQuery/polling/index.vue'], resolve);                // 额度查询中

const bindOuterCardII = resolve => require(['@/views/quotaQuery/bindOuterCardII/index.vue'], resolve);

const loan = resolve => require(['@/views/loan/index.vue'], resolve);                                           // 借款
//const auth = resolve => require(['@/views/loan/auth/index.vue'], resolve);                                      // 认证列表
const loanFaceidVerify = resolve => require(['@/views/loan/faceidVerify/index.vue'], resolve);                  // 借款人脸认证
const loanResult = resolve => require(['@/views/loan/result/index.vue'], resolve);                              // 借款结果
const loanPolling = resolve => require(['@/views/loan/polling/index.vue'], resolve);                            // 贷款查询中
const loanExamining = resolve => require(['@/views/loan/examine/index.vue'], resolve);                            // 受托支付-审核中/审核失败

const repayment = resolve => require(['@/views/repayment/index.vue'], resolve);                                 // 还款
const repaymentList = resolve => require(['@/views/repayment/repaymentList/index.vue'], resolve);               // 提前还款
const planList = resolve => require(['@/views/repayment/planList/index.vue'], resolve);                         // 所有按期还款的计划列表
const repaymentInputAmount = resolve => require(['@/views/repayment/repaymentInputAmount.vue'], resolve)        // 按期还息、到期还本的金额输入页面

const detail = resolve => require(['@/views/detail/index.vue'], resolve); // 详情
const loanMoreDetail = resolve => require(['@/views/detail/more/index.vue'], resolve); // 更多借款详情

const record = resolve => require(['@/views/record/index.vue'], resolve); // 记录
const loanRecord = resolve => require(['@/views/record/loan/index.vue'], resolve); // 借款记录
const repayRecord = resolve => require(['@/views/record/repay/index.vue'], resolve); // 还款记录

const pay = resolve => require(['@/views/pay/index.vue'], resolve);                                               // 支付
const payResult = resolve => require(['@/views/pay/result/index.vue'], resolve);                                  // 支付结果
const payDiscount = resolve => require(['@/views/pay/discount/index.vue'], resolve);                              // 支付红包

const user = resolve => require(['@/views/user/index.vue'], resolve);                                             // 个人中心入口页
const addContact = resolve => require(['@/views/user/addContact/index.vue'], resolve);                            // 紧急联系人
const addWorkInfo = resolve => require(['@/views/user/addWorkInfo/index.vue'], resolve);                            // 职业信息
const userInfo = resolve => require(['@/views/user/userInfo/index.vue'], resolve);                                // 用户信息
const workInfo = resolve => require(['@/views/user/workInfo/index.vue'], resolve);                                // 职业信息
const bankCardManage = resolve => require(['@/views/user/bankCardManage/index.vue'], resolve);                    // 银行卡管理
const companyManage = resolve => require(['@/views/user/companyManage/index.vue'], resolve);                      // 企业信息管理
const contactManage = resolve => require(['@/views/user/contactManage/index.vue'], resolve);                      // 联系人管理
const userAccount = resolve => require(['@/views/user/userAccount/index.vue'], resolve);                          // 电子账户信息
const transIn = resolve => require(['@/views/user/userAccount/transIn/index.vue'], resolve);                          // 电子账户转入
const feaceidDemo = resolve => require(['@/views/feaceidDemo/index.vue'], resolve);                               // 电子账户信息
const coupon = resolve => require(['@/views/user/coupon/index.vue'], resolve);                                    // 优惠券卷包
const useableCoupon = resolve => require(['@/views/user/coupon/useable.vue'], resolve);                             // 可用优惠券
const overdueCoupon = resolve => require(['@/views/user/coupon/overdue.vue'], resolve);                             // 失效优惠券
const loanOrder = resolve => require(['@/views/user/loanOrder/index.vue'], resolve);                               // 借款订单
const uploadProf = resolve => require(['@/views/user/uploadProf/index.vue'], resolve);                             // 上传用款证明
const setting = resolve => require(['@/views/user/setting/index.vue'], resolve);
const editPhone = resolve => require(['@/views/user/setting/editPhone/index.vue'], resolve);
const userSettle = resolve => require(['@/views/user/userSettle/index.vue'], resolve);                             // 结清证明
const settleItems = resolve => require(['@/views/user/userSettle/items/index.vue'], resolve);                      // 结清证明列表
const pdfProve = resolve => require(['@/views/user/userSettle/pdfProve/pdfIndex.vue'], resolve);                      // pdf结清证明

const helper = resolve => require(['@/views/helper/index.vue'], resolve);                                       // 帮助页面
const helperList = resolve => require(['@/views/helper/list/index.vue'], resolve);                              // 帮助列表
const helperDetail = resolve => require(['@/views/helper/detail/index.vue'], resolve);                          // 帮助详情
const notWhitePage = resolve => require(['@/views/notWhitePage/index.vue'], resolve);                           // 不在白名单内
const ocr = resolve => require(['@/views/ocr/index.vue'], resolve);                                             // ocr
const offlinePromotion = resolve => require(['@/views/offlinePromotion/index.vue'], resolve);                   // 线下推广

// 20200507lpr网贷签约
const lpr = resolve => require(['@/views/lpr/index.vue'], resolve);                                     // lpr首页
const lprGuide = resolve => require(['@/views/lpr/guide/index.vue'], resolve);                          // 操作流程
const lprReg = resolve => require(['@/views/lpr/reg/index.vue'], resolve);                              // 注册
const lprIdCardConfirm = resolve => require(['@/views/lpr/idCardConfirm/index.vue'], resolve);          // 身份证认证
const lprFaceidVerify = resolve => require(['@/views/lpr/faceidVerify/index.vue'], resolve);            // lpr人脸
const lprMortgage = resolve => require(['@/views/lpr/mortgage/index.vue'], resolve);                          // 操作流程
const lprInterestRateChange = resolve => require(['@/views/lpr/interestRateChange/index.vue'], resolve);      // 利率转换要素
const lprSignConfirm = resolve => require(['@/views/lpr/signConfirm/index.vue'], resolve);                    // 签约身份确认
const lprSignResult = resolve => require(['@/views/lpr/signResult/index.vue'], resolve);                // 签约结果页
const lprSignProgress = resolve => require(['@/views/lpr/signProgress/index.vue'], resolve);                // 签约结果页
const lprPromotion = resolve => require(['@/views/lpr/promotion/index.vue'], resolve);                // 推广页
const lprContract = resolve => require(['@/views/lpr/contract/index.vue'], resolve);                  // 合同
const lprUser = resolve => require(['@/views/lpr/user/index.vue'], resolve);                          // lpr个人中心入口页

const loanContract = resolve => require(['@/components/pdf/Index.vue'], resolve)                  // 花无忧借款合同
const loanContract2 = resolve => require(['@/components/pdf/Index2.vue'], resolve)                  // 借款合同

const updating = resolve => require(['@/views/updating/index.vue'], resolve);                          // 系统维护更新升级页
/*
* 税银贷
* */
// const taxHome = resolve => require(['@/views/taxHome/index.vue'], resolve);                                // 税银贷-首页
// const taxEnterpriseCertification = resolve => require(['@/views/taxEnterpriseCertification/index.vue'], resolve);         // 税银贷-企业
// const taxMyEnterprise = resolve => require(['@/views/taxMyEnterprise/index.vue'], resolve);   // 税银贷-我的企业
// const taxloan = resolve => require(['@/views/taxloan/index.vue'], resolve);
// const taxSupplement = resolve => require(['@/views/taxSupplement/index.vue'], resolve);
// const supplementContact = resolve => require(['@/views/taxSupplementContact/index.vue'], resolve);
// const taxContract = resolve => require(['@/views/taxContract/index.vue'], resolve);
// const taxLoanReal = resolve => require(['@/views/taxloan_real/index.vue'], resolve);
// const taxpolling = resolve => require(['@/views/taxloan_real/polling/index.vue'], resolve)
// const taxWaitPolling = resolve => require(['@/views/taxWaitComponent/index.vue'], resolve)
// const taxNoCredit = resolve => require(['@/views/taxNoCredit/index.vue'], resolve) // 无可用额度
/*
* 农户贷
* */
// const farmerHome = resolve => require(['@/views/farmerHome/index.vue'], resolve)
// const farmerRegister = resolve => require(['@/views/farmerRegister/index.vue'], resolve)
// const farmerSupplement = resolve => require(['@/views/farmerSupplement/index.vue'], resolve)
// const farmerContact = resolve => require(['@/views/farmerContact/index.vue'], resolve)
// const farmerContract = resolve => require(['@/views/farmerContract/index.vue'], resolve);
// const farmerPolling = resolve => require(['@/views/farmerWaitComponent/index.vue'], resolve)
// const farmerLoan = resolve => require(['@/views/farmerLoan/index.vue'], resolve)
// const farmerLoanPolling = resolve => require(['@/views/farmerLoan/polling/index.vue'], resolve)
// const farmerIdCardConfirm = resolve => require(['@/views/farmerIdCardConfirm/index.vue'], resolve);                  // ocr信息确认页
/**
 * 对接普惠签约
 */
const phSign = resolve => require(['@/views/puhui/index.vue'], resolve) // 普惠签约

/**
 * 客户经理管理（白名单）
 */
const signIn = resolve => require(['@/views/accountManager/signIn/index.vue'], resolve) // 登录页
const center = resolve => require(['@/views/accountManager/center/index.vue'], resolve) // 客户经理中心
const performanceMag = resolve => require(['@/views/accountManager/performanceMag/index.vue'], resolve) // 绩效管理
const overdueCustomers = resolve => require(['@/views/accountManager/overdueCustomers/index.vue'], resolve) // 逾期客户列表
const customerMag = resolve => require(['@/views/accountManager/customerMag/index.vue'], resolve) // 客户管理
const customerDetail = resolve => require(['@/views/accountManager/customerDetail/index.vue'], resolve) // 客户详情
const creditResult = resolve => require(['@/views/accountManager/creditResult/index.vue'], resolve) // 授信结果
const identityInformation = resolve => require(['@/views/accountManager/identityInformation/index.vue'], resolve) // 客户身份信息
const basicInformation = resolve => require(['@/views/accountManager/basicInformation/index.vue'], resolve) // 基础信息
const contactInformation = resolve => require(['@/views/accountManager/contactInformation/index.vue'], resolve) // 联系人信息
const letterUsage = resolve => require(['@/views/accountManager/letterUsage/index.vue'], resolve) // 用信情况

// 多产品
const navPage = resolve => require(['@/views/nav/index.vue'], resolve) // 导航菜单页
const productList = resolve => require(['@/views/productList/index.vue'], resolve) // 产品列表页
const login = resolve => require(['@/views/login/index.vue'], resolve) // 登录页面
const identityInfo = resolve => require(['@/views/login/identity-info.vue'], resolve) // 身份信息认证页面
const supplementInfo = resolve => require(['@/views/login/supplement-info.vue'], resolve) // 补充个人信息页面
const supplementContact = resolve => require(['@/views/login/supplement-contact.vue'], resolve); // 补充联系人信息
const agreementSigning = resolve => require(['@/views/login/agreement-signing.vue'], resolve) // 协议签署页面-首页
const agreementContent = resolve => require(['@/views/login/agreement-content.vue'], resolve) // 协议签署页面-协议内容
const qnHome = resolve => require(['@/views/qnHome/index.vue'], resolve); // 多产品首页
const qnTaxEnterpriseCertification = resolve => require(['@/views/qnTaxEnterpriseCertification/index.vue'], resolve) // 税银贷-企业
const qnTaxMyEnterprise = resolve => require(['@/views/qnTaxMyEnterprise/index.vue'], resolve); // 申请贷款企业列表
const taxEnterpriseMock = resolve => require(['@/views/taxEnterpriseMock/index.vue'], resolve)
const qnWaitPolling = resolve => require(['@/views/qnWaitPolling/index.vue'], resolve) // 额度评估中
const qnNoCredit = resolve => require(['@/views/qnNoCredit/index.vue'], resolve) // 无可用额度
const qnLoan = resolve => require(['@/views/qnLoan/index.vue'], resolve) // 借款
const qnContract = resolve => require(['@/views/qnContract/index.vue'], resolve) // 合约签订
const qnPolling = resolve => require(['@/views/qnPolling/index.vue'], resolve) // 申请借款后等待中
const qnBindCard = resolve => require(['@/views/qnBindCard/index.vue'], resolve); // 绑卡、换绑卡
const openSecondAccount = resolve => require(['@/views/qnBindCard/open-second-account.vue'], resolve); // 开二类户
const newRepaymentList = resolve => require(['@/views/repayment/newRepaymentList.vue'], resolve); // 提前还款
const newPlanList = resolve => require(['@/views/repayment/newPlanList.vue'], resolve) // 按期还款
const loanDetail = resolve => require(['@/views/detail/loan/index.vue'], resolve); // 借款详情
const modifyIdentity = resolve => require(['@/views/modify/index.vue'], resolve) // 修改身份信息

export default new Router({
    routes: [
        {
            path: '*',
            component: notFind,
            meta: {
                showTime: true
            }
        },
        {
            path: '/',
            component: productList,
            meta: {
                showTime: true
            },
            beforeEnter: (to, from, next) => {
                // 设置流程起点标记
                sessionStorage.setItem('FLOW_ORIGIN_PATH', '/productList')
                next()
            }
        },
        {
            path: '/navPage',
            name: 'navPage',
            component: navPage,
            meta: {
                showTime: true
            }
        },
        {
            path: '/home',
            name: 'home',
            component: home,
            meta: {
                showTime: true
            }
        },
        {
            path: '/offlinePromotion',
            name: 'offlinePromotion',
            component: offlinePromotion,
            meta: {

            }
        },
        {
            path: '/quotaQuery',
            name: 'quotaQuery',
            component: quotaQuery,
            children: [
                {
                    path: 'formAdditional',
                    name: 'formAdditional',
                    component: formAdditional,
                    meta: {
                        auth: true,
                        showTime: true,
                        process: true
                    }
                },
                {
                    path: 'polling',
                    name: 'polling',
                    component: quotaQueryPolling,
                    meta: {
                        auth: true,
                        showTime: true
                    }
                }
            ],
            meta: {
                auth: true,
                process: true,
                showTime: true
            }
        },
        {
            path: '/quotaQueryFaceidVerify',
            name: 'quotaQueryFaceidVerify',
            component: quotaQueryFaceidVerify,
            meta: {
                auth: true,
                process: true,
                showTime: true
            }
        },
        {
            path: '/quotaQueryResult',
            name: 'quotaQueryResult',
            component: quotaQueryResult,
            meta: {
                auth: true,
                process: true,
                showTime: true
            }
        },
        {
            path: '/idCardConfirm',
            name: 'idCardConfirm',
            component: idCardConfirm,
            meta: {
                auth: true,
                showTime: true
            }
        },
        {
            path: '/bindOuterCardII',
            name: 'bindOuterCardII',
            component: bindOuterCardII,
            meta: {
                auth: true,
                showTime: true,
                process: true
            }
        },
        {
            path: '/loan',
            name: 'loan',
            component: loan,
            children: [
                {
                    path: 'faceidVerify',
                    name: 'loanFaceidVerify',
                    component: loanFaceidVerify,
                    meta: {
                        auth: true,
                        showTime: true,
                        process: true,
                    }
                },
                {
                    path: 'polling',
                    name: 'loanPolling',
                    component: loanPolling,
                    meta: {
                        auth: true,
                        showTime: true
                    }
                },
            ],
            meta: {
                auth: true,
                process: true,
                showTime: true
            }
        },
        {
            path: '/loanExamining',
            name: 'loanExamining',
            component: loanExamining,
            meta: {
                auth: true,
                showTime: true
            }
        },
        {
            path: '/loanResult',
            name: 'loanResult',
            component: loanResult,
            meta: {
                auth: true,
                showTime: true
            }
        },
        {
            path: '/repayment',
            name: 'repayment',
            component: repayment,
            children: [
                // {
                //     path: 'repaymentList',
                //     name: 'repaymentList',
                //     component: repaymentList,
                //     meta: {
                //         auth: true,
                //         showTime: true,
                //         process: true,
                //         register: true
                //     }
                // },
                {
                    path: 'repaymentList',
                    name: 'repaymentList',
                    component: newRepaymentList,
                    meta: {
                        auth: true,
                        showTime: true,
                        process: true,
                        register: true
                    }
                },
                // {
                //     path: 'planList',
                //     name: 'planList',
                //     component: planList,
                //     meta: {
                //         auth: true,
                //         showTime: true,
                //         process: true,
                //         register: true
                //     }
                // },
                {
                    path: 'planList',
                    name: 'planList',
                    component: newPlanList,
                    meta: {
                        auth: true,
                        showTime: true,
                        process: true,
                        register: true
                    }
                }
            ],
            meta: {
                auth: true,
                showTime: true,
                process: true,
                register: true
            }
        },
        {
            path: '/repaymentInputAmount',
            name: 'repaymentInputAmount',
            component: repaymentInputAmount,
            meta: {
                auth: true,
                showTime: true,
                process: true,
                register: true,
                name: '提前还款'
            }
        },
        {
            path: '/detail',
            name: 'detail',
            component: detail,
            children: [
                {
                    path: 'loan',
                    name: 'loanDetail',
                    component: loanDetail,
                    meta: {
                        auth: true,
                        showTime: true
                    }
                },
                {
                    path: 'more',
                    name: 'loanMoreDetail',
                    component: loanMoreDetail,
                    meta: {
                        auth: true,
                        showTime: true
                    }
                },
            ],
            meta: {
                auth: true,
                showTime: true
            }
        },
        {
            path: '/record',
            name: 'record',
            component: record,
            children: [
                {
                    path: 'loan',
                    name: 'loanRecord',
                    component: loanRecord,
                    meta: {
                        auth: true,
                        showTime: true
                    }
                },
                {
                    path: 'repay',
                    name: 'repayRecord',
                    component: repayRecord,
                    meta: {
                        auth: true,
                        showTime: true
                    }
                },
            ],
            meta: {
                auth: true,
                showTime: true
            }
        },
        {
            path: '/pay',
            name: 'pay',
            component: pay,
            meta: {
                auth: true,
                showTime: true
            }
        },
        {
            path: '/payResult',
            name: 'payResult',
            component: payResult,
            meta: {
                auth: true,
                showTime: true
            }
        },
        {
            path: '/payDiscount',
            name: 'payDiscount',
            component: payDiscount,
            meta: {
                auth: true,
                showTime: true
            }
        },
        {
            path: '/loanContract',
            name: 'loanContract',
            component: loanContract,
            meta: {
                showTime: true
            }
        },
        {
            path: '/loanContract2',
            name: 'loanContract2',
            component: loanContract2,
            meta: {
                showTime: true
            }
        },
        {
            path: '/user',
            name: 'user',
            component: user,
            children: [
                {
                    path: 'info',
                    name: 'userInfo',
                    component: userInfo,
                    meta: {
                        auth: true,
                        showTime: true
                    }
                },
                {
                    path: 'workInfo',
                    name: 'workInfo',
                    component: workInfo,
                    meta: {
                        auth: true,
                        showTime: true
                    }
                },
                {
                    path: 'account',
                    name: 'userAccount',
                    component: userAccount,
                    meta: {
                        auth: true,
                        showTime: true
                    }
                },
                {
                    path: 'trans-in',
                    name: 'transIn',
                    component: transIn,
                    meta: {
                        auth: true,
                        showTime: true
                    }
                },
                {
                    path: 'bankCardManage',
                    name: 'bankCardManage',
                    component: bankCardManage,
                    meta: {
                        auth: true,
                        showTime: true
                    }
                },
                {
                    path: 'companyManage',
                    name: 'companyManage',
                    component: companyManage,
                    meta: {
                        auth: true,
                        showTime: true
                    }
                },
                {
                    path: 'contactManage',
                    name: 'contactManage',
                    component: contactManage,
                    meta: {
                        auth: true,
                        showTime: true
                    }
                }
            ],
            meta: {
                auth: true,
                showTime: true,
                process: true,
                register: true
            }
        },
        // 结清证明
        {
            path: '/userSettle',
            name: 'userSettle',
            component: userSettle,
            meta: {
                auth: true,
                showTime: true
            }
        },
        {
            path: '/settleItems',
            name: 'settleItems',
            component: settleItems,
            meta: {
                auth: true,
                showTime: true
            }
        },
        {
            path: '/pdfProve',
            name: 'pdfProve',
            component: pdfProve,
            meta: {
                auth: true,
                showTime: true
            }
        },
        {
            path: '/addContact',
            name: 'addContact',
            component: addContact,
            meta: {
                auth: true,
                showTime: true,
                process: true
            }
        },
        {
            path: '/addWorkInfo',
            name: 'addWorkInfo',
            component: addWorkInfo,
            meta: {
                auth: true,
                showTime: true,
                process: true
            }
        },
        {
            path: '/loanOrder',
            name: 'loanOrder',
            component: loanOrder,
            meta: {
                auth: true,
                showTime: true
            }
        },
        {
            path: '/uploadProf',
            name: 'uploadProf',
            component: uploadProf,
            meta: {
                auth: true,
                showTime: true
            }
        },
        {
            path: '/setting',
            name: 'setting',
            component: setting,
            meta: {
                auth: true,
                showTime: true
            }
        },
        {
            path: '/edit-phone',
            name: 'editPhone',
            component: editPhone,
            meta: {
                auth: true,
                showTime: true
            }
        },
        {
            path: '/coupon',
            name: 'coupon',
            component: coupon,
            children: [
                {
                    path: 'overdue',
                    name: 'overdueCoupon',
                    component: overdueCoupon,
                    meta: {
                        auth: true,
                        showTime: true
                    }
                },
                {
                    path: 'useable',
                    name: 'useableCoupon',
                    component: useableCoupon,
                    meta: {
                        auth: true,
                        showTime: true
                    }
                },
            ],
            meta: {
                auth: true,
                showTime: true
            }
        },
        {
            path: '/helper',
            name: 'helper',
            component: helper,
            meta: {
                showTime: true
            }
        },
        {
            path: '/helperList',
            name: 'helperList',
            component: helperList,
            meta: {
                showTime: true
            }
        },
        {
            path: '/helperDetail',
            name: 'helperDetail',
            component: helperDetail,
            meta: {
                showTime: true
            }
        },
        {
            path: '/notWhitePage',
            name: 'notWhitePage',
            component: notWhitePage
        },
        {
            path: '/feaceidDemo',
            name: 'feaceidDemo',
            component: feaceidDemo,
            meta: {
                auth: true,
                showTime: true
            }
        },
        {
            path: '/ocr',
            name: 'ocr',
            component: ocr,
            meta: {
                auth: true,
                showTime: true
            }
        },
        {
            path: '/lpr',
            name: 'lpr',
            component: lpr,
            meta: {
                showTime: true,
            }
        },
        {
            path: '/lprGuide',
            name: 'lprGuide',
            component: lprGuide,
            meta: {
                auth: true,
                showTime: true,
            }
        },
        {
            path: '/lprReg',
            name: 'lprReg',
            component: lprReg,
            meta: {
                showTime: true,
                auth: true,
                lprProcess: true
            }
        },
        {
            path: '/lprIdCardConfirm',
            name: 'lprIdCardConfirm',
            component: lprIdCardConfirm,
            meta: {
                auth: true,
                showTime: true
            }
        },
        {
            path: '/lprFaceidVerify',
            name: 'lprFaceidVerify',
            component: lprFaceidVerify,
            meta: {
                auth: true,
                showTime: true,
                lprProcess: true
            }
        },
        {
            path: '/lprMortgage',
            name: 'lprMortgage',
            component: lprMortgage,
            meta: {
                auth: true,
                showTime: true,
                lprProcess: true
            }
        },
        {
            path: '/lprInterestRateChange',
            name: 'lprInterestRateChange',
            component: lprInterestRateChange,
            meta: {
                auth: true,
                showTime: true,
                lprProcess: true
            }
        },
        {
            path: '/lprSignConfirm',
            name: 'lprSignConfirm',
            component: lprSignConfirm,
            meta: {
                auth: true,
                showTime: true
            }
        },
        {
            path: '/lprSignResult',
            name: 'lprSignResult',
            component: lprSignResult,
            meta: {
                auth: true,
                showTime: true
            }
        },
        {
            path: '/lprSignProgress',
            name: 'lprSignProgress',
            component: lprSignProgress,
            meta: {
                showTime: true
            }
        },
        {
            path: '/lprPromotion',
            name: 'lprPromotion',
            component: lprPromotion,
            meta: {
                auth: true,
                showTime: true
            }
        },
        {
            path: '/lprContract',
            name: 'lprContract',
            component: lprContract,
            meta: {
                showTime: true
            }
        },
        {
            path: '/lprUser',
            name: 'lprUser',
            component: lprUser,
            meta: {
                showTime: true,
                auth: true,
                lprProcess: true
            }
        },
        {
            path: '/updating',
            name: 'updating',
            component: updating,
            meta: {
                showTime: true,
            }
        },

        /**
         * 对接普惠签约页面
         */
        {
            path: '/ph-sign',
            name: 'ph-sign',
            component: phSign
        },

        /**
         * 税银贷路由
         */

        // 主页
        // {
        //     path: '/tax-home',
        //     name: 'tax-home',
        //     component: taxHome
        // },
        // 企业身份认证
        // {
        //     path: '/tax-enterprise',
        //     name: 'tax-enterprise',
        //     component: taxEnterpriseCertification,
        // },
        // 我的企业
        // {
        //     path: '/tax-myEnterprise',
        //     name: 'tax-myEnterprise',
        //     component: taxMyEnterprise
        // },
        // 借款 身份证 ocr 四要素
        // {
        //     path: '/tax-loan',
        //     name: 'tax-loan',
        //     component: taxloan
        // },
        // 补充个人信息
        // {
        //     path: '/tax-supplement',
        //     name: 'tax-supplement',
        //     component: taxSupplement
        // },
        // 补充联系人信息
        // {
        //     path: '/tax-supplementContact',
        //     name: 'tax-supplementContact',
        //     component: supplementContact
        // },
        // 等待组件
        // {
        //     path: '/tax-wait-polling',
        //     name: 'tax-wait-polling',
        //     component: taxWaitPolling
        // },
        // 签署合同
        // {
        //     path: '/tax-contract',
        //     name: 'tax-contract',
        //     component: taxContract
        // },
        // 借款
        // {
        //     path: '/tax-loan-real',
        //     name: 'tax-loan-real',
        //     component: taxLoanReal
        // },
        // 申请借款后等待中
        // {
        //     path: '/tax-polling',
        //     name: 'tax-polling',
        //     component: taxpolling
        // },
        // 税务认证mock
        {
            path: '/tax-enterprisemock',
            name: 'tax-enterprisemock',
            component: taxEnterpriseMock
        },
        // 无可用额度
        // {
        //     path: '/tax-nocredit',
        //     name: 'tax-nocredit',
        //     component: taxNoCredit
        // },

        /**
         * 农户贷路由
         */
        // 主页
        // {
        //     path: '/farmer-home',
        //     name: 'farmer-home',
        //     component: farmerHome
        // },
        // 四要素
        // {
        //     path: '/farmer-register',
        //     name: 'farmer-register',
        //     component: farmerRegister
        // },
        // 补充个人信息
        // {
        //     path: '/farmer-supplement',
        //     name: 'farmer-supplement',
        //     component: farmerSupplement
        // },
        // 补充联系人信息
        // {
        //     path: '/farmer-contact',
        //     name: 'farmer-contact',
        //     component: farmerContact
        // },
        // {
        //     path: '/farmer-contract',
        //     name: 'farmer-contract',
        //     component: farmerContract
        // },
        // polling
        // {
        //     path: '/farmer-polling',
        //     name: 'farmer-polling',
        //     component: farmerPolling
        // },
        // 借款
        // {
        //     path: '/farmer-loan',
        //     name: 'farmer-loan',
        //     component: farmerLoan
        // },
        // 申请借款后等待中
        // {
        //     path: '/farmer-loan-polling',
        //     name: 'farmer-loan-polling',
        //     component: farmerLoanPolling
        // },
        // 身份信息确认
        // {
        //     path: '/farmerIdCardConfirm',
        //     name: 'farmerIdCardConfirm',
        //     component: farmerIdCardConfirm
        // },
        /**
         * 客户经理管理(二维码)
         * 20210604
         */
        // 登录页
        {
            path: '/signIn',
            name: 'signIn',
            component: signIn
        },
        // 客户经理中心
        {
            path: '/center',
            name: 'center',
            component: center
        },
        // 绩效管理
        {
            path: '/performanceMag',
            name: 'performanceMag',
            component: performanceMag
        },
        // 逾期客户列表
        {
            path: '/overdueCustomers',
            name: 'overdueCustomers',
            component: overdueCustomers
        },
        // 客户管理
        {
            path: '/customerMag',
            name: 'customerMag',
            component: customerMag
        },
        // 客户详情
        {
            path: '/customerDetail',
            name: 'customerDetail',
            component: customerDetail
        },
        // 授信结果
        {
            path: '/creditResult',
            name: 'creditResult',
            component: creditResult
        },
        // 客户身份信息
        {
            path: '/identityInformation',
            name: 'identityInformation',
            component: identityInformation
        },
        // 基础信息
        {
            path: '/basicInformation',
            name: 'basicInformation',
            component: basicInformation
        },
        // 联系人信息
        {
            path: '/contactInformation',
            name: 'contactInformation',
            component: contactInformation
        },
        // 用信情况
        {
            path: '/letterUsage',
            name: 'letterUsage',
            component: letterUsage
        },
        // ------------------------------以下内容为多产品路由------------------------------
        // 产品列表页
        {
            path: '/productList',
            name: 'productList',
            component: productList,
            beforeEnter: (to, from, next) => {
                // 设置流程起点标记
                sessionStorage.setItem('FLOW_ORIGIN_PATH', '/productList')
                next()
            }
        },
        // 登录页
        {
            path: '/login',
            name: 'login',
            component: login
        },
        // 身份信息认证页
        {
            path: '/identity-info',
            name: 'identity-info',
            component: identityInfo
        },
        // 补充个人信息页
        {
            path: '/supplement-info',
            name: 'supplement-info',
            component: supplementInfo
        },
        // 补充联系人信息
        {
            path: '/supplement-contact',
            name: 'supplement-contact',
            component: supplementContact
        },
        // 协议签署页-首页（协议展示）
        {
            path: '/agreement-signing',
            name: 'agreement-signing',
            component: agreementSigning
        },
        // 协议签署页-协议内容（协议展示）
        {
            path: '/agreement-content',
            name: 'agreement-content',
            component: agreementContent
        },
        // 产品首页
        {
            path: '/qn-home',
            name: 'qn-home',
            component: qnHome
        },
        // 税银贷企业所在地
        {
            path: '/qn-tax-enterpriseCertification',
            name: 'qn-tax-enterpriseCertification',
            component: qnTaxEnterpriseCertification
        },
        // 税银贷申请贷款企业列表
        {
            path: '/qn-tax-myEnterprise',
            name: 'qn-tax-myEnterprise',
            component: qnTaxMyEnterprise
        },
        // 额度评估中
        {
            path: '/qn-wait-polling',
            name: 'qn-wait-polling',
            component: qnWaitPolling
        },
        // 立即借款
        {
            path: '/qn-loan',
            name: 'qn-loan',
            component: qnLoan
        },
        // 签署合同
        {
            path: '/qn-contract',
            name: 'qn-contract',
            component: qnContract
        },
        // 申请借款后等待中
        {
            path: '/qn-polling',
            name: 'qn-polling',
            component: qnPolling
        },
        // 无可用额度
        {
            path: '/qn-no-credit',
            name: 'qn-no-credit',
            component: qnNoCredit
        },
        // 绑卡、换绑卡
        {
            path: '/qn-bind-card',
            name: 'qn-bind-card',
            component: qnBindCard
        },
        // 开二类户发短信
        {
            path: '/open-second-account',
            name: 'open-second-account',
            component: openSecondAccount
        },
        // 修改身份信息
        {
            path: '/modify-identity',
            name: 'modify-identity',
            component: modifyIdentity
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js